// OneDrive:IgnoreCodeCoverage

import { createSingleEvent } from '../SingleEventBase';
import { IEventType } from '../EventBase';
import { IEvent, EventFieldType } from '../IEvent';
export interface IPLTSingleSchema {
    /**
     * The name of the PLT event
     */
    name: string;
    /**
     * Time to get the aspx from the server
     */
    w3cResponseEnd: number;
    /**
     * Time it takes for our app to *start* prefetching
     */
    prefetchStart: number;
    /**
     * Time it takes for defered list data render from server
     */
    deferredListDataRender: number;
    /**
     * Time it takes for our app to *start* running
     */
    appStart: number;
    /**
     * Time it takes for our app to make the relevant data fetch for this view
     */
    preRender: number;
    /**
     * Time it takes for our app to get data back from the server
     */
    dataFetch: number;
    /**
     * time the datafetch request spent on the server
     */
    dataFetchServerTime: number;
    /**
     * Time it takes from appDataFetchEnd to PLT
     */
    postRender: number;
    /**
     * Post render plus pre render
     */
    render: number;
    /**
     * Time from fetchStart to plt
     */
    plt: number;
    /**
     * Time from navigationStart to plt
     */
    pltWithUnload: number;
    /**
     * The count of http request till plt
     */
    httpRequests: number;
    /**
     * Whether this page load is served from appCache
     */
    appCacheHit: boolean;
    /**
     * DNS lookup time
     */
    dns: number;
    /**
     * TCP connect time
     */
    tcpConnect: number;
    /**
     * SSL connect time
     */
    sslConnect: number;
}

export interface IPLT extends IEvent {
    data: IPLTSingleSchema;
}

export type PLT = IPLT;

export const PLT: IPLTType = createSingleEvent<IPLTSingleSchema>({
    eventName: 'PLT,',
    shortEventName: 'PLT',
    samplingFeature: { ODB: true, ODC: 'PLTLoggingSampling', Fallback: false }
}, {
    name: {
        isKey: true,
        type: EventFieldType.String
    },
    w3cResponseEnd: EventFieldType.Number,
    prefetchStart: EventFieldType.Number,
    deferredListDataRender: EventFieldType.Number,
    appStart: EventFieldType.Number,
    preRender: EventFieldType.Number,
    dataFetch: EventFieldType.Number,
    dataFetchServerTime: EventFieldType.Number,
    postRender: EventFieldType.Number,
    render: EventFieldType.Number,
    plt: EventFieldType.Number,
    pltWithUnload: EventFieldType.Number,
    httpRequests: EventFieldType.Number,
    appCacheHit: EventFieldType.Boolean,
    dns: EventFieldType.Number,
    tcpConnect: EventFieldType.Number,
    sslConnect: EventFieldType.Number
});

export interface IPLTType extends IEventType<IPLTSingleSchema> {
    prototype: PLT;
    /**
     * This will create a single PLT event
     * @param data {IPLTSingleSchema}     * -required name - The name of the PLT event
     * -required w3cResponseEnd - Time to get the aspx from the server
     * -required prefetchStart - Time it takes for our app to *start* prefetching
     * -required deferredListDataRender - Time it takes for defered list data render from server
     * -required appStart - Time it takes for our app to *start* running
     * -required preRender - Time it takes for our app to make the relevant data fetch for this view
     * -required dataFetch - Time it takes for our app to get data back from the server
     * -required dataFetchServerTime - time the datafetch request spent on the server
     * -required postRender - Time it takes from appDataFetchEnd to PLT
     * -required render - Post render plus pre render
     * -required plt - Time from fetchStart to plt
     * -required pltWithUnload - Time from navigationStart to plt
     * -required httpRequests - The count of http request till plt
     * -required appCacheHit - Whether this page load is served from appCache
     * -required dns - DNS lookup time
     * -required tcpConnect - TCP connection time
     * -required sslConnect - SSL connection time
     * @param parent {IEvent} The optional parent for this event
     */
    logData(this: typeof PLT, data?: IPLTSingleSchema, parent?: IEvent): PLT;
}

export default PLT;
